import axios from 'axios'
import store from '@/store';
import router from '@/router';
// import { AUTH_EXPIRED, REQUEST_FAILURE } from '../../store/types.js'

var baseInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_BASE_URL
})

baseInstance.interceptors.request.use(
  config => {
    // store.commit('START_LOADING');
    const token = localStorage.getItem('user-token');

    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }

    return config
})

baseInstance.interceptors.response.use(
  response => {
    // store.commit('FINISH_LOADING');
    return response
  },
  error => {
    // store.commit('FINISH_LOADING');
    if (error.response) {
      if (401 === error.response.status) {
        store.dispatch("app/requestFailure", error.response.data.message);
        store.dispatch("auth/authExpired");
        router.push('/authenticate');
      } else {
        store.dispatch("app/requestFailure", error.response.data.message);
      }
      return Promise.reject(error);
    } else {
      store.dispatch("app/requestFailure", error.response.data.message);
      return Promise.reject(error);
    }
});


var customerInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_BASE_URL
})

customerInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      if (401 === error.response.status) {
        store.dispatch("app/requestFailure", error.response.data.message);
        // store.dispatch("auth/authExpired");
        // router.push('/authenticate');
      } else {
        store.dispatch("app/requestFailure", error.response.data.message);
      }
      return Promise.reject(error);
    } else {
      store.dispatch("app/requestFailure", error.response.data.message);
      return Promise.reject(error);
    }
});

export default {
  baseInstance,
  customerInstance
}
